import script from "./acquaint-popout-text-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-popout-text-area.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-popout-text-area.vue?vue&type=style&index=0&id=edf3e2b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edf3e2b4"]])

export default __exports__